export default function () {

  $(document).ready(function () {

    function numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function recalculateForm(thisForm) {
      const field1 = Number($('[name=number-shift]', thisForm).val()) || 0;
      const field2 = Number($('[name=number-pay]', thisForm).val()) || 0;
      const field3 = Number($('[name=number-cost]', thisForm).val()) || 0;
      const theAmount = (field1 * (field2 + field3)).toFixed(0);
      const theSaving = (theAmount * .35).toFixed(0);
      const whoArray = ($(thisForm).prop('id')).split('-');
      const theID = whoArray[whoArray.length - 1];
      $(`#total-savings-${theID}`).text(`$${numberWithCommas(theSaving)}`);
      $(`#total-costs-${theID}`).text(`$${numberWithCommas(theAmount)}`);
      $(`#total-shifts-${theID}`).text(field1);
      $(`#total-shifts2-${theID}`).text(field1);
    }

    function updateSlider(slideSource, inputName) {
      const parentForm = $(slideSource).closest('form');
      const slideAmount = slideSource.value;
      $(`[name=${inputName}]`, parentForm).val(slideAmount);
      recalculateForm(parentForm);
    }

    window.updateSlider = updateSlider;
    $('form.calculator-form').each(function () {
      recalculateForm($(this));
    });
  });
}



// WEBPACK FOOTER //
// ./themes/app/src/js/calculator-block.js